import React, { useMemo } from 'react';
import { Chart } from 'primereact/chart';
import { useSelector, useDispatch } from 'react-redux';
import { loadImportationsTimelineAsync, selectImportationsTimeline } from '../dashboardSlice';
import { ChartCard } from './ChartCard';
import { useThemeVersion } from '../../../useTheme';

export const ImportationsTimelineChart = () => {
    const dispatch = useDispatch();
    const { data, status, error } = useSelector(selectImportationsTimeline);
    // getComputedStyle abaixo só lê o CSS de novo se essa memo recalcular —
    // sem isso, trocar de tema depois de montado deixa a cor antiga presa.
    const themeVersion = useThemeVersion();

    const chartData = useMemo(() => {
        if (!Array.isArray(data) || !data.length) {
            return {
                labels: [],
                datasets: []
            };
        }

        // Agrupa os dados por data e status
        const groupedData = data.reduce((acc, item) => {
            const date = new Date(item.date).toLocaleDateString('pt-BR');
            if (!acc[date]) {
                acc[date] = { success: 0, failure: 0 };
            }
            if (item.status === 'success') {
                acc[date].success += 1;
            } else if (item.status === 'failure') {
                acc[date].failure += 1;
            }
            return acc;
        }, {});

        // Ordena as datas
        const sortedDates = Object.keys(groupedData).sort((a, b) => {
            return new Date(a.split('/').reverse().join('-')) - new Date(b.split('/').reverse().join('-'));
        });

        return {
            labels: sortedDates,
            datasets: [
                {
                    label: 'Sucesso',
                    data: sortedDates.map(date => groupedData[date].success),
                    borderColor: '#4CAF50',
                    backgroundColor: 'rgba(76, 175, 80, 0.1)',
                    tension: 0.4,
                    fill: true
                },
                {
                    label: 'Falha',
                    data: sortedDates.map(date => groupedData[date].failure),
                    borderColor: '#f44336',
                    backgroundColor: 'rgba(244, 67, 54, 0.1)',
                    tension: 0.4,
                    fill: true
                }
            ]
        };
    }, [data]);

    const chartOptions = useMemo(() => ({
        plugins: {
            legend: {
                labels: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color'),
                    usePointStyle: true
                }
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        return `${context.dataset.label}: ${context.raw} importações`;
                    }
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color')
                },
                grid: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border')
                }
            },
            y: {
                beginAtZero: true,
                ticks: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--text-color'),
                    stepSize: 1
                },
                grid: {
                    color: getComputedStyle(document.documentElement).getPropertyValue('--surface-border')
                }
            }
        },
        maintainAspectRatio: false
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [themeVersion]);

    return (
        <ChartCard
            title="Timeline de importações"
            loading={status === 'loading'}
            error={error}
            onReload={() => dispatch(loadImportationsTimelineAsync())}
        >
            <div style={{ minHeight: '238px' }}>
                <Chart type="line" data={chartData} options={chartOptions} />
            </div>
        </ChartCard>
    );
}; 